import PropTypes from "prop-types";
import React, { Component } from "react";
import classNames from "classnames";
import getClassNameFactory from "@emcm-ui/utility-class-names";
import { SVGIcon } from "@emcm-ui/component-icon/lib/svg";

class Panel extends Component {
  static propTypes = {
    /**
     * Content to show inside the Panel.
     */
    children: PropTypes.node,

    /**
     * Callback when back button is activated
     */
    onBack: PropTypes.func,

    /**
     * Whether or not this panel is open
     */
    open: PropTypes.bool,

    /**
     * Title to show in the bar.
     */
    title: PropTypes.string
  };

  static getDerivedStateFromProps(props, state) {
    if (props.open) {
      return {
        animating: true,
        closed: false
      };
    }

    if (!props.open && state.closed === false) {
      return {
        animating: true,
        closed: true
      };
    }

    return {};
  }

  constructor(props) {
    super(props);

    this.state = {
      // this.state.closed is trinary:
      // - null: has not been opened, therefore has not been closed. Default.
      // - false: the menu is open.
      // - true: the menu had been opened previously, but is now closed.
      // This assists in animating correctly.
      closed: null
    };

    this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
  }

  handleAnimationEnd() {
    this.setState({ animating: false });
  }

  render() {
    const { children, onBack, open, title } = this.props;
    const { animating, closed } = this.state;
    const getClassName = getClassNameFactory("SiteHeaderPanel");

    return (
      <div
        className={getClassName({
          states: classNames({
            animating,
            closed,
            open
          })
        })}
        onAnimationEnd={this.handleAnimationEnd}
      >
        <div className={getClassName({ descendantName: "bar" })}>
          <button
            className={getClassName({ descendantName: "backButton" })}
            onClick={onBack}
          >
            <SVGIcon name="caret" size="s" />
          </button>

          <div className={getClassName({ descendantName: "barTitle" })}>
            {title}
          </div>
        </div>
        <div className={getClassName({ descendantName: "inner" })}>
          {children}
        </div>
      </div>
    );
  }
}

export default Panel;
